import {
	createRouter,
	createWebHashHistory
} from 'vue-router';

const routers = [{
		path: '/login',
		name: '登录',
		component: () => import('@/pages/login/index.vue'),
		hidden: true,
	},
	{
		path: '/register',
		name: '注册',
		component: () => import('@/pages/register/index.vue'),
		hidden: true,
	},
	{
		path: '/forgot',
		name: '忘记密码',
		component: () => import('@/pages/forgot/index.vue'),
		hidden: true,
	},
	{
		path: '/echartsIndex',
		name: '数据分析',
		component: () => import('@/pages/echartsPage/index/index.vue'),
		hidden: true,
	},
	{
		path: '/',
		name: '工作台',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '工作台',
			icon: 'House',
		},
		children: [{
				path: '/',
				name: '工作台',
				component: () => import('@/pages/index/index.vue'),
			},
			{
				path: '/product',
				name: '产品管理',
				component: () => import('@/pages/deviceAdmin/product/index.vue'),
			},
			{
				path: '/sysManagement',
				name: '系统管理',
				component: () => import('@/pages/systemAdmin/sysManagement/index.vue'),
			},
			{
				path: '/fishType',
				name: '鱼种管理',
				component: () => import('@/pages/fishAdmin/fishType/index.vue'),
			},
			{
				path: '/repairOrder',
				name: '设备维保工单',
				component: () => import('@/pages/deviceAdmin/repairOrder/index.vue'),
			},
			{
				path: '/maintenanceDetails',
				name: '维保详情',
				component: () =>
					import('@/pages/deviceAdmin/repairOrder/maintenanceDetails.vue'),
			},
			{
				path: '/otaList',
				name: '固件和升级',
				component: () => import('@/pages/systemAdmin/otaList/index.vue'),
			},
			{
				path: '/otaUpgrade',
				name: '固件升级',
				component: () => import('@/pages/systemAdmin/otaUpgrade/index.vue'),
			},
			{
				path: '/deviceTpl',
				name: '设备模版',
				component: () => import('@/pages/deviceAdmin/deviceTpl/index.vue'),
			},
			{
				path: '/deviceLocation',
				name: '安装位置管理',
				component: () => import('@/pages/deviceAdmin/deviceLocation/index.vue'),
			},
			{
				path: '/device',
				name: '开关设备',
				component: () => import('@/pages/deviceAdmin/device/index.vue'),
			},
			{
				path: '/myDevice',
				name: '我的设备',
				component: () => import('@/pages/deviceAdmin/device/myDevice.vue'),
			},
			{
				path: '/plug',
				name: '智能插座',
				component: () => import('@/pages/deviceAdmin/plug/index.vue'),
			},
			{
				path: '/camera',
				name: '摄像头',
				component: () => import('@/pages/deviceAdmin/camera/index.vue'),
			},
			{
				path: '/offlineCount',
				name: '离线统计',
				component: () => import('@/pages/alarmAdmin/offlineCount/index.vue'),
			},
			{
				path: '/alarmLog',
				name: '告警日志',
				component: () => import('@/pages/alarmAdmin/alarmLog/index.vue'),
			},
			{
				path: '/alarmAccount',
				name: '告警账户',
				component: () => import('@/pages/alarmAdmin/alarmAccount/index.vue'),
			},
			{
				path: '/recharge',
				name: '充值',
				component: () => import('@/pages/alarmAdmin/alarmAccount/recharge.vue'),
			},
			{
				path: '/rechargeHistory/:accountId',
				name: '充值记录',
				component: () =>
					import('@/pages/alarmAdmin/alarmAccount/rechargeHistory.vue'),
				props: true,
			},
			{
				path: '/surplus/:accountId',
				name: '套餐余量',
				component: () => import('@/pages/alarmAdmin/alarmAccount/surplus.vue'),
				props: true, // 关键：把路由参数映射为组件 props
			},
			{
				path: '/detail/:accountId',
				name: '产品详情',
				component: () => import('@/pages/deviceAdmin/product/detail.vue'),
				props: true,
			},
			{
				path: '/option/:deviceId',
				name: '操作设备',
				component: () => import('@/pages/deviceAdmin/device/option.vue'),
				props: true,
			},
			{
				path: '/alarmOrder',
				name: '告警工单',
				component: () => import('@/pages/alarmAdmin/alarmOrder/index.vue'),
			},
			{
				path: '/ticketDetails',
				name: '告警详情',
				component: () =>
					import('@/pages/alarmAdmin/alarmOrder/ticketDetails.vue'),
			},
			{
				path: '/alarmMember',
				name: '告警联系人',
				component: () => import('@/pages/alarmAdmin/alarmMember/index.vue'),
			},
			{
				path: '/alarmSetting',
				name: '接警配置',
				component: () => import('@/pages/alarmAdmin/alarmSetting/index.vue'),
			},
			{
				path: '/alarmPushRecord',
				name: '告警推送记录',
				component: () => import('@/pages/alarmAdmin/alarmPushRecord/index.vue'),
			},
			{
				path: '/alarmRule',
				name: '告警规则 ',
				component: () => import('@/pages/alarmAdmin/alarmRule/index.vue'),
			},
			{
				path: '/alarmAccount',
				name: '告警消费账户',
				component: () => import('@/pages/systemAdmin/account/index.vue'),
			},
			{
				path: '/loginLog',
				name: '登录日志',
				component: () => import('@/pages/opMaintenance/loginLog/index.vue'),
			},
			{
				path: '/exceptionLog',
				name: '异常日志',
				component: () => import('@/pages/opMaintenance/exceptionLog/index.vue'),
			},
			{
				path: '/fbManagement',
				name: '用户反馈管理',
				component: () => import('@/pages/fbManagement/index.vue'),
			},
			{
				path: '/orgStructure',
				name: '组织结构管理',
				component: () => import('@/pages/systemAdmin/department/index.vue'),
			},
			{
				path: '/role',
				name: '角色管理',
				component: () => import('@/pages/systemAdmin/role/index.vue'),
			},
			{
				path: '/user',
				name: '用户管理',
				component: () => import('@/pages/systemAdmin/user/index.vue'),
			},
			{
				path: '/sysConfiguration',
				name: '平台配置',
				component: () =>
					import('@/pages/systemAdmin/sysConfiguration/index.vue'),
			},
			{
				path: '/tenantManagement',
				name: '租户管理',
				component: () => import('@/pages/tenantManagement/index.vue'),
			},
			{
				path: '/userManagement',
				name: '用户管理1',
				component: () => import('@/pages/userManagement/index.vue'),
			},
			{
				path: '/menu',
				name: '菜单管理',
				component: () => import('@/pages/systemAdmin/menu/index.vue'),
			},
			{
				path: '/alarmPackage',
				name: '告警充值套餐',
				component: () => import('@/pages/systemAdmin/alarmPackage/index.vue'),
			},
			{
				path: '/sysVar',
				name: '系统参数',
				component: () => import('@/pages/systemAdmin/sysVar/index.vue'),
			},
			{
				path: '/permissionPoint',
				name: '权限点管理',
				component: () =>
					import('@/pages/systemAdmin/permissionPoint/index.vue'),
			},
			{
				path: '/sysDictionary',
				name: '字典管理',
				component: () =>
					import('@/pages/systemSetting/sysDictionary/index.vue'),
			},
			{
				path: '/auditLog',
				name: '系统审计日志',
				component: () => import('@/pages/sysAudit/auditLog/index.vue'),
			},
			{
				path: '/myAccount',
				name: '账号管理',
				component: () => import('@/pages/myAccount/index.vue'),
			},
		],
	},
];
const router = createRouter({
	history: createWebHashHistory(),
	base: process.env.BASE_URL,
	routes: routers,
});
export default router;